import {Responsive} from "./Responsive";
import {getWindowDimension, getDeviceTypeInfo, isMobileDevice, isTabletDevice, isLaptopDevice, isBiggerThanLaptop} from "./utilResponsive";

export {
    Responsive,
    getDeviceTypeInfo,
    getWindowDimension,
    isMobileDevice, 
    isTabletDevice, 
    isLaptopDevice, 
    isBiggerThanLaptop
}
